import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { EIPDatePickerComponent } from 'eipdate-picker';
import { CommonService } from 'src/app/Service/Common.service';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { PendingDrawingStatus } from 'src/app/ViewModel/Tender-Quantity.Model';

@Component({
  selector: 'app-pending-drawing-status',
  templateUrl: './pending-drawing-status.component.html',
  styleUrls: ['./pending-drawing-status.component.css']
})
export class PendingDrawingStatusComponent implements OnInit {
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public isCLient!: boolean;
  public obj: any;
  public enableFilter = false;
  public projectElements: IProjectElementsOutput[] = [];
  public pendingDrawingStatus: PendingDrawingStatus[] = [];
  DCI_Type!: FormGroup;
  numElements: Map<string, string> = new Map<string, string>();

  @ViewChild('todatePicker') dateRange!: EIPDatePickerComponent;
  ShowSearch: boolean = false;

  constructor(private _projInfoService: ProjectInfoService, private _formBuilder: FormBuilder,
    private _commonService: CommonService, private dialog: MatDialog, private dashboardService: DashboardService
  ) { }

  viewData(data: any) {
    this.finalView(data);
  }
  ngOnInit() {
    this.obj = "pending_drawing_status";
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.callMemberRoleandFeature();

    this.finalView({
      "project_Id": this.projectId,
      "group_Id": this.groupId,
      "from_Date": null,
      "to_Date": null,
      "stages": null,
      "schedule_Type": null,
      "drg_Type": null,
      "disc_Id": null,
      "struct_Id": null,
      "Dynamic_Id": []
    });

  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.pendingDrawingStatus
    };
    return result;
  }


  toggleShowSearch() {
    this.ShowSearch = !this.ShowSearch;
  }

  async callMemberRoleandFeature() {
    this._commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {
      result = result.filter(data => data.role_Desc != 'Client');
      if (result.length > 0) {
        this.isCLient = false;
      }
      else {
        this.isCLient = true;
      }
    });
  }

  finalView(obj?: any) {
    this.dashboardService.GetPendingDrawingStatus(obj).subscribe(data => {
      this.pendingDrawingStatus = data;
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

}
